import React, { useEffect, useState } from "react";
import DashboardWrapper from "../../../components/DashboardWrapper";
import CrudTable from "../../../components/dashboard/table/CrudTable";

import transactionService from "../../../services/transactionService";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader";

export default function ReadAllTransaction() {
  const navigate = useNavigate();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
const [searchText, setSearchText] = useState("");
  // Table columns to show
  const columns = [
    "sl",
    "transaction_id",
    "order_id",
    "payment_method",
    "amount",
    "order_invoice",
    "created_at",
  ];

  const fetchTransactions = async () => {
    try {
      const response = await transactionService.getAllTransactions();

      const formatted = response.data.map((t, index) => ({
        sl: index + 1,
        ...t,
        order_invoice: (t.order?.invoice_id || "N/A").toUpperCase(),
        created_at: new Date(t.created_at).toLocaleString("en-GB", {
          weekday: "short", 
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true, 
        }),
      }));

      setTransactions(formatted);
    } catch (error) {
      console.error("Error fetching transactions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  const handleEdit = (row) => navigate(`/admin/order/${row.order_id}`);
  const handleDelete = () => {};

  return (
    <DashboardWrapper>
      <div className="container-fluid mt-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <button
            className="btn btn-secondary d-flex align-items-center"
            onClick={() => navigate(-1)}
          >
            <span>Back</span>
          </button>
        </div>

        <div className="card shadow">
                      <div className="card-header d-flex flex-wrap justify-content-between align-items-center gap-3">
       <h4 className="mb-0">All Transactions</h4>

  <input
    type="text"
    className="form-control"
    placeholder="Search products..."
    value={searchText}
    onChange={(e) => setSearchText(e.target.value)}
    style={{
      width: "260px",
      maxWidth: "100%",
      borderRadius: "6px",
    }}
  />
</div>

          <div className="card-body">
            {loading ? (
              <Loader />
            ) : (
              <CrudTable
                data={transactions}
                onEdit={handleEdit}
                onDelete={handleDelete}
                columns={columns} 
                 searchText={searchText}
              />
            )}
          </div>
        </div>
      </div>
    </DashboardWrapper>
  );
}
